import React, { useState } from 'react';
import Button from './Button';
import Modal from './Modal';
import ModalContent from './ModalContent';
import ModalCloseButton from './ModalCloseButton';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant,
  isDangerous = false,
  loading = false,
}) => {
  const [confirming, setConfirming] = useState(false);
  const isBusy = loading || confirming;
  const resolvedConfirmVariant = confirmVariant ?? (isDangerous ? 'danger' : 'primary');

  const handleConfirm = async () => {
    if (isBusy || !onConfirm) return;

    setConfirming(true);
    try {
      await onConfirm();
    } finally {
      setConfirming(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnBackdropClick={false} className="z-[60]">
      <ModalContent size="small" constrainHeight={false}>
        <ModalCloseButton onClose={onClose} />
        <div className="flex items-center mb-4">
          {isDangerous && (
            <div className="flex-shrink-0 mr-3">
              <div className="w-10 h-10 bg-danger-light rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-danger" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                  />
                </svg>
              </div>
            </div>
          )}
          <div>
            <h3 className="text-lg font-medium text-text-primary">{title}</h3>
          </div>
        </div>

        <div className="mb-6">
          {typeof message === 'string' || typeof message === 'number' ? (
            <p className="text-sm text-text-secondary">{message}</p>
          ) : (
            <div className="text-sm text-text-secondary">{message}</div>
          )}
        </div>

        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end sm:space-x-3 sm:gap-0">
          <Button
            onClick={onClose}
            variant="secondary"
            size="small"
            disabled={isBusy}
            className="w-full sm:w-auto"
          >
            {cancelText}
          </Button>
          <Button
            onClick={handleConfirm}
            variant={resolvedConfirmVariant}
            size="small"
            disabled={isBusy}
            className="w-full sm:w-auto"
          >
            {confirmText}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmationModal;
